module.exports = __webpack_public_path__ + "frontend/img/icon_error.fca8c636.svg";